import { RouteHandler } from 'wee-routes';
import $ from 'wee-dom';
import $events from 'wee-events';
import $screen from 'wee-screen';

class Hero {
    constructor() {
        this.$videoWrapper = $(':videoWrapper');
        this.$tiles = $(':tiles');
        this.$tile = $(':heroTile');
        this.$hero = $(':hero');
        this.$header = $(':siteHeader');
        this.$video = $(':heroVideo');
        this.$image = $(':heroImage');
        this.$heading = $(':heroHeading');
        this.playing = '-is-playing';
    }

    play(id) {
        const $video = $(`:video-${id}`);
        const $heading = $(`:heading-${id}`);

        if (! this.$videoWrapper.hasClass(this.playing)) {
            this.$videoWrapper
                .show()
                .addClass(this.playing);
        }

        $video.show();

        if ($video[0].play) {
            $video[0].play();
        }

        this.$heading.hide();
        $heading.show();
    }

    stop(id) {
        const $video = $(`:video-${id}`);
        const $image = $(`:image-${id}`);
        const $heading = $(`:heading-${id}`);

        this.$videoWrapper.hide();
        this.$videoWrapper.removeClass(this.playing);

        if ($video.length) {
            $video.hide()[0].pause();
        } else if ($image.length) {
            this.hideImage(id);
        }

        $heading.hide();
        $(':heading-initial').show();
    }

    checkMedia(el, id) {
        const $heading = $(`:heading-${id}`);

        if ($(`:video-${id}`).length) {
            if (! $(el).data('loaded')) {
                this.loadVideo(el, id);
            } else {
                this.play(id);
            }
        } else {
            this.loadImage(id);
            this.$heading.hide();
            $heading.show();
        }
    }

    loadVideo(el, id) {
        const $tile = $(el);
        const $video = $(`:video-${id}`);

        if ($video.length) {
            $video.attr('src', $video.data('src'));

            $tile.data('loaded', true);
            this.play($tile.data('id'));
        }
    }

    loadImage(id) {
        const $image = $(`:image-${id}`);

        if ($image.length) {
            this.$videoWrapper.show();
            $image.show();
        }
    }

    hideImage() {
        this.$image.hide();
    }
}

export default new RouteHandler({
    init() {
        const hero = new Hero();

        $screen.map([
            {
                max: 3,
                callback: () => {
                    $events.off(false, '.hero');
                },
            },
            {
                min: 4,
                callback: () => {
                    $events.on({
                        [hero.$tile.sel]: {
                            mouseenter(e, el) {
                                const $el = $(el);
                                const id = $el.data('id');

                                hero.checkMedia(el, id);
                            },
                            mouseleave(e, el) {
                                hero.stop($(el).data('id'));
                            },
                            focus(e, el) {
                                const id = $(el).data('id');
                                hero.checkMedia(el, id);
                            },
                            blur(e, el) {
                                hero.stop($(el).data('id'));
                            },
                        },
                    }, {
                        namespace: 'hero',
                    });
                },
            },
        ]);
    },
});
